/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminPlayerTrainingAttendance
 */
export interface AdminPlayerTrainingAttendance {
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerTrainingAttendance
     */
    attendanceId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerTrainingAttendance
     */
    trainingId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerTrainingAttendance
     */
    sessionId?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerTrainingAttendance
     */
    trainingName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AdminPlayerTrainingAttendance
     */
    sessionDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerTrainingAttendance
     */
    startTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerTrainingAttendance
     */
    endTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminPlayerTrainingAttendance
     */
    present: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminPlayerTrainingAttendance
     */
    late?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminPlayerTrainingAttendance
     */
    paid: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerTrainingAttendance
     */
    amountPaid?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerTrainingAttendance
     */
    trainingFee?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerTrainingAttendance
     */
    sessionExtraFee?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerTrainingAttendance
     */
    expectedFee?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerTrainingAttendance
     */
    paymentMode?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AdminPlayerTrainingAttendance
     */
    recurringBillingPeriodStart?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AdminPlayerTrainingAttendance
     */
    recurringBillingPeriodEnd?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AdminPlayerTrainingAttendance
     */
    recurringValidFrom?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminPlayerTrainingAttendance
     */
    recurringBasePaid?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerTrainingAttendance
     */
    recurringBaseAmountPaid?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerTrainingAttendance
     */
    recurringExpectedAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerTrainingAttendance
     */
    comment?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AdminPlayerTrainingAttendance
     */
    markedAt?: Date | null;
}

/**
 * Check if a given object implements the AdminPlayerTrainingAttendance interface.
 */
export function instanceOfAdminPlayerTrainingAttendance(value: object): value is AdminPlayerTrainingAttendance {
    if (!('attendanceId' in value) || value['attendanceId'] === undefined) return false;
    if (!('trainingId' in value) || value['trainingId'] === undefined) return false;
    if (!('present' in value) || value['present'] === undefined) return false;
    if (!('paid' in value) || value['paid'] === undefined) return false;
    return true;
}

export function AdminPlayerTrainingAttendanceFromJSON(json: any): AdminPlayerTrainingAttendance {
    return AdminPlayerTrainingAttendanceFromJSONTyped(json, false);
}

export function AdminPlayerTrainingAttendanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPlayerTrainingAttendance {
    if (json == null) {
        return json;
    }
    return {
        
        'attendanceId': json['attendanceId'],
        'trainingId': json['trainingId'],
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'trainingName': json['trainingName'] == null ? undefined : json['trainingName'],
        'sessionDate': json['sessionDate'] == null ? undefined : (new Date(json['sessionDate'])),
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'present': json['present'],
        'late': json['late'] == null ? undefined : json['late'],
        'paid': json['paid'],
        'amountPaid': json['amountPaid'] == null ? undefined : json['amountPaid'],
        'trainingFee': json['trainingFee'] == null ? undefined : json['trainingFee'],
        'sessionExtraFee': json['sessionExtraFee'] == null ? undefined : json['sessionExtraFee'],
        'expectedFee': json['expectedFee'] == null ? undefined : json['expectedFee'],
        'paymentMode': json['paymentMode'] == null ? undefined : json['paymentMode'],
        'recurringBillingPeriodStart': json['recurringBillingPeriodStart'] == null ? undefined : (new Date(json['recurringBillingPeriodStart'])),
        'recurringBillingPeriodEnd': json['recurringBillingPeriodEnd'] == null ? undefined : (new Date(json['recurringBillingPeriodEnd'])),
        'recurringValidFrom': json['recurringValidFrom'] == null ? undefined : (new Date(json['recurringValidFrom'])),
        'recurringBasePaid': json['recurringBasePaid'] == null ? undefined : json['recurringBasePaid'],
        'recurringBaseAmountPaid': json['recurringBaseAmountPaid'] == null ? undefined : json['recurringBaseAmountPaid'],
        'recurringExpectedAmount': json['recurringExpectedAmount'] == null ? undefined : json['recurringExpectedAmount'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'markedAt': json['markedAt'] == null ? undefined : (new Date(json['markedAt'])),
    };
}

export function AdminPlayerTrainingAttendanceToJSON(json: any): AdminPlayerTrainingAttendance {
    return AdminPlayerTrainingAttendanceToJSONTyped(json, false);
}

export function AdminPlayerTrainingAttendanceToJSONTyped(value?: AdminPlayerTrainingAttendance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attendanceId': value['attendanceId'],
        'trainingId': value['trainingId'],
        'sessionId': value['sessionId'],
        'trainingName': value['trainingName'],
        'sessionDate': value['sessionDate'] == null ? value['sessionDate'] : value['sessionDate'].toISOString().substring(0,10),
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'present': value['present'],
        'late': value['late'],
        'paid': value['paid'],
        'amountPaid': value['amountPaid'],
        'trainingFee': value['trainingFee'],
        'sessionExtraFee': value['sessionExtraFee'],
        'expectedFee': value['expectedFee'],
        'paymentMode': value['paymentMode'],
        'recurringBillingPeriodStart': value['recurringBillingPeriodStart'] == null ? value['recurringBillingPeriodStart'] : value['recurringBillingPeriodStart'].toISOString().substring(0,10),
        'recurringBillingPeriodEnd': value['recurringBillingPeriodEnd'] == null ? value['recurringBillingPeriodEnd'] : value['recurringBillingPeriodEnd'].toISOString().substring(0,10),
        'recurringValidFrom': value['recurringValidFrom'] == null ? value['recurringValidFrom'] : value['recurringValidFrom'].toISOString().substring(0,10),
        'recurringBasePaid': value['recurringBasePaid'],
        'recurringBaseAmountPaid': value['recurringBaseAmountPaid'],
        'recurringExpectedAmount': value['recurringExpectedAmount'],
        'comment': value['comment'],
        'markedAt': value['markedAt'] == null ? value['markedAt'] : value['markedAt'].toISOString(),
    };
}

